import { Component } from "react";
import { componentStyles } from "./boards-carousel-component.scss";
import StoriesSlickCarouselComponent from "/components/core/community/home/stories-slick-carousel/stories-slick-carousel-component";
import colors from "/styles/colors";
import LeftArrow from "/static/svg/arrow-left-no-fill.svg";
import RightArrow from "/static/svg/arrow-right2.svg";
import VisibilitySensor from "react-visibility-sensor";
import { XS } from "constants/vp-sizes";
import { isMobile } from "/utils/mobile";
import { fixDevImageUrl } from "/services/community/url-service";
import { trackEvent } from "/services/bigbrain-service";
import { CAROUSEL_SWITCH_BOARD_CLICKED } from "/constants/bigbrain-event-types";
import CarouselRoundArrowComponent from "/components/core/carousel-arrow/carousel-round-arrow-component";
import classnames from "classnames";

import BoardsCarouselItemComponent from "./boards-carousel-item/boards-carousel-item-component";

const mod = (x, y) => {
  return ((x % y) + y) % y;
};

export default class BoardsCarouselComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onCarouselMounted = this.onCarouselMounted.bind(this);
    this.beforeChange = this.beforeChange.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.onItemClick = this.onItemClick.bind(this);
    this.onLeftClick = this.onLeftClick.bind(this);
    this.onRightClick = this.onRightClick.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
  }

  onVisibilityChange(visible, data) {
    const { stopAutoSlide, startAutoSlide } = this.props;
    if (stopAutoSlide && startAutoSlide) {
      visible ? stopAutoSlide() : startAutoSlide();
    }
  }

  renderItem(item, index) {
    const { aboveTheFold } = this.props;
    const url = fixDevImageUrl(item.boardImage);
    const borderColor = !isMobile() ? colors[item.color] : "none";

    return (
      <BoardsCarouselItemComponent
        key={index}
        index={index}
        url={url}
        borderColor={borderColor}
        item={item}
        onClick={this.onItemClick}
        aboveTheFold={aboveTheFold}
      />
    );
  }

  onCarouselMounted(el) {
    this._carousel = el;
  }

  onLeftClick() {
    const { changing } = this.state;
    if (changing) return;
    const { setActive, active, quotes } = this.props;
    const nextActive = mod(active - 1, quotes.length);
    trackEvent(CAROUSEL_SWITCH_BOARD_CLICKED, { kind: "quotesArrow" });
    setActive(nextActive);
  }

  onRightClick() {
    const { changing } = this.state;
    if (changing) return;
    const { setActive, active, quotes } = this.props;
    const nextActive = mod(active + 1, quotes.length);
    trackEvent(CAROUSEL_SWITCH_BOARD_CLICKED, { kind: "quotesArrow" });
    setActive(nextActive);
  }

  beforeChange(prevIndex, nextIndex) {
    const { setActive, active } = this.props;
    this.currentActiveSlide = nextIndex;

    if (!isMobile() && active != nextIndex) {
      setActive(nextIndex);
    }
  }

  slideTo(prev, current) {
    const n = this.props.quotes.length;
    if (!this._carousel) return;

    if (current == (prev + 1) % n) {
      this._carousel.slickNext();
    } else if (current == (((prev - 1) % n) + n) % n) {
      this._carousel.slickPrev();
    } else {
      this._carousel.slickGoTo(current);
    }
  }
  onItemClick(itemIndex) {
    const { active } = this.props;
    trackEvent(CAROUSEL_SWITCH_BOARD_CLICKED, { kind: "boardClicked" });
    this.slideTo(active, itemIndex);
  }

  shouldComponentUpdate(nextProps) {
    const { active, showNavigationArrows } = nextProps;
    return this.currentActiveSlide !== active || showNavigationArrows !== this.props.showNavigationArrows;
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.active;
    const current = this.props.active;

    this.slideTo(prev, current);
  }

  multipleQuotes() {
    const { quotes } = this.props;
    if (!quotes) return false;
    return quotes.length > 1;
  }

  render() {
    const { quotes, active, showNavigationArrows, removeBoardBorder, aboveTheFold } = this.props;
    const renderNavigationArrows = this.multipleQuotes() && showNavigationArrows;
    const showBoardsArrows = this.multipleQuotes() && !showNavigationArrows;

    return (
      <div className="boards-carousel-component">
        <div
          className={classnames("boards-carousel-frame", {
            "remove-border": removeBoardBorder,
            "above-the-fold": aboveTheFold
          })}
        >
          <StoriesSlickCarouselComponent
            autoplay={false}
            items={quotes}
            renderItem={this.renderItem}
            slidesToShow={1}
            slidesToScroll={1}
            dots={false}
            onCarouselMounted={this.onCarouselMounted}
            initialSlide={active}
            variableWidth={false}
            active={true}
            speed={800}
            minWidthForCarousel={XS}
            beforeChange={this.beforeChange}
            arrows={showBoardsArrows}
            centerMode={true}
            nextArrow={<CarouselRoundArrowComponent />}
            prevArrow={<CarouselRoundArrowComponent />}
          />

          {renderNavigationArrows && (
            <div className="custom-arrows">
              <div className="custom-arrow left-arrow" onClick={this.onLeftClick}>
                <LeftArrow />
              </div>
              <div className="custom-arrow right-arrow" onClick={this.onRightClick}>
                <RightArrow />
              </div>
            </div>
          )}

          <VisibilitySensor
            partialVisibility={false}
            onChange={this.onVisibilityChange}
            active={true}
            scrollCheck={true}
          >
            <div className="stop-area" />
          </VisibilitySensor>
        </div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

BoardsCarouselComponent.defaultProps = {
  showNavigationArrows: true,
  removeBoardBorder: false
};
